// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__eMcbV","id":"style__id__Ml6yF","notes":"style__notes__6aO1Y","rating":"style__rating__9SBq0"};